defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ClubWelcome',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'Common/Framework/EventHandling/Scripts/CrossWindowEvents',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/Authentification/Scripts/LoginCache',
    'DanskeSpil/Domain/Authentification/Scripts/LoginController',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Models/PlayTogetherClub',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/HelpButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PageWrapper',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubCard',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PromotionSpots'
  ],
  function (Component, CrossWindowEvents, Params, LoginCache, LoginController, PlayTogetherDictionary, PlayTogetherApi, PlayTogetherClubModel, Loader, HelpButton, CtaButton, PageWrapper, ClubCard, PromotionSpots) {

    // Component:
    Component('club-welcome', [PlayTogetherDictionary], function (m, route, settings) {

      // Components:
      var root = {
        controller: function () {
          this.linkGroupId = m.prop(Params.extract('klubId'));
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'ClubWelcome/' });
          this.isLoading = m.prop(true);
          this.error = m.prop(null);
          this.promotionSpots = settings.promotionSpots;
          this.onboardingFlowOne = {
            slides: settings.onboardingFlowOne || [],
            title: this.dictionary('OnboardingTitle')
          };
          this.onboardingFlowTwo = {
            slides: settings.onboardingFlowTwo || [],
            title: this.dictionary('OnboardingTitleTwo')
          };
          this.userIsLoggedIn = m.prop(LoginCache.isLoggedIn());
          this.createAccountLink = settings.createAccountLink;
          this.clubModel = m.prop(null);
          this.clubLocked = m.prop(true);
          this.navigationPaths = settings.navigation;

          CrossWindowEvents.subscribe('ds.event.getUserDataFromSitecore', function () {
            this.userIsLoggedIn(LoginCache.isLoggedIn());
            m.redraw();
          }.bind(this));

          if (this.linkGroupId()) {
            PlayTogetherApi.getInvitationDetails(this.linkGroupId()).then(function (response) {
              const clubData = response;
              this.clubModel(new PlayTogetherClubModel(clubData));
              this.clubLocked(!this.clubModel().fields.rules.isOpenForRegistration());
              this.isLoading(false);
              m.redraw();
            }.bind(this), function (response) {
              this.error(response);
              this.isLoading(false);
              m.redraw();
            }.bind(this));
          }

          this.openLogin = function () {
            LoginController.openLogin();
          }.bind(this);

          this.acceptInvitation = () => {
            const groupId = this.clubModel().fields.clubId();
            const data = {
              linkGroupId: this.clubModel().fields.linkClubId()
            };

            PlayTogetherApi.acceptInvitation(groupId, data).then(() => {
              window.location.href = this.navigationPaths.clubPage + '?klubId=' + groupId;
            }, (response) => {
              this.error(response);
              m.redraw();
            });
          };
        },

        view: function (controller) {
          // Loading:
          if (controller.isLoading()) {
            return Loader(controller);
          }

          if (controller.error()) {
            return PageWrapper({
              $content: m('.play-together__blocked-page-text', controller.error())
            });
          }

          const pageDescription = () => {
            if (controller.userIsLoggedIn()) {
              return controller.dictionary('PageDescription', { CHAIRMAN: controller.clubModel().fields.chairman().name });
            }
            if (controller.clubLocked()) {
              return controller.dictionary('ClubLockedDescription');
            }

            return null;
          };

          const pageTitle = () => {
            if (controller.clubLocked()) {
              return controller.dictionary('ClubLockedTitle');
            }

            return controller.dictionary('PageTitle', { CLUB: controller.clubModel().fields.clubName() });
          };

          const $content = () => {
            return [
              m(ClubCard, {
                controller: {
                  rootDictionary: controller.rootDictionary,
                  navigationPaths: controller.navigationPaths,
                  settings: settings
                },
                club: controller.clubModel(),
                asInvitation: true,
                action: {
                  text: controller.dictionary('AcceptInvitationButton'),
                  action: controller.acceptInvitation,
                  options: ['yellow']
                }
              }),
              m('.play-together-content-section', [
                m('.play-together-content-section__title', controller.dictionary('AboutTitle')),
                m('.play-together-content-section__description', m.trust(controller.dictionary('AboutDescription'))),
                CtaButton({
                  text: controller.dictionary('SeeGuideButton'),
                  href: controller.navigationPaths.guidePage
                })
              ]),
              m(PromotionSpots, { controller })
            ];
          };

          const pageClassName = () => {
            let className = 'play-together-club-welcome';
            if (controller.clubLocked()) {
              className += ' play-together-club-welcome--club-locked';
            }
            return className;
          };

          return PageWrapper({
            className: pageClassName(),
            $header: {
              title: pageTitle(),
              subtitle: pageDescription(),
              className: 'justified-content',
              actions: {

                helpbutton: [
                  HelpButton({
                    title: controller.dictionary('HelpOverlay/Title'),
                    description: controller.dictionary('HelpOverlay/Description'),
                    closeButtonLabel: controller.rootDictionary.get('Shared/CloseButton'),
                  })
                ]

              }
            },
            $content: $content()
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
